export const onlyNumber = (event) => {
  if (event?.charCode < 48 || event?.charCode > 58) {
    event.preventDefault();
  }
};
export const onlyNumberWithExpression = (e) => {
  const allowedCharsRegex = /[0-9.+*-]/; // Allow digits, '.', '+', '-', '*'
  if (!allowedCharsRegex.test(e.key)) {
    e.preventDefault();
  }
};
export const evaluateExpression = (input) => {
  // Regular expression to match basic arithmetic expressions with +, -, and decimals
  const expressionRegex = /^(\d+(\.\d+)?)([+-])(\d+(\.\d+)?)$/;
  const match = input.match(expressionRegex);

  if (match) {
    const num1 = parseFloat(match[1]);
    const operator = match[3];
    const num2 = parseFloat(match[4]);

    let result;
    if (operator === "+") {
      result = num1 + num2;
    } else if (operator === "-") {
      result = num1 - num2;
    }

    // Return the result rounded to two decimal places
    return result.toFixed(2);
  }

  // If input doesn't match the pattern, return input as is
  return input;
};
export const onlyNumberdesimalFordeductedAmount = (event) => {
  const { key, target } = event;
  const { value, selectionStart, selectionEnd } = target;

  // Allow navigation & control keys
  if (
    key === "Backspace" ||
    key === "Delete" ||
    key === "ArrowLeft" ||
    key === "ArrowRight" ||
    key === "Tab"
  ) {
    return;
  }

  // Allow one decimal point
  if (key === ".") {
    if (value.includes(".")) {
      event.preventDefault(); // block second dot
    }
    return;
  }

  // Block anything that's not a digit (0-9)
  if (!/^[0-9]$/.test(key)) {
    event.preventDefault();
    return;
  }

  // Simulate new value after typing
  const newValue =
    value.substring(0, selectionStart) + key + value.substring(selectionEnd);

  // Restrict to 2 decimal places
  const parts = newValue.split(".");
  if (parts.length === 2 && parts[1].length > 2) {
    event.preventDefault();
  }
};

export const onlyNumberdesimal = (event) => {
  const charCode = event.which ? event.which : event.keyCode;
  const input = event.target.value;
  const selectionStart = event.target.selectionStart;

  if (
    charCode === 8 || // backspace
    (charCode >= 37 && charCode <= 40) || // arrow keys
    (charCode === 46 && input.indexOf(".") === -1) // dot (only if not present)
  ) {
    return;
  }

  const newChar = String.fromCharCode(charCode);

  // Prevent non-digit characters (excluding dot)
  if (!/[\d.]/.test(newChar)) {
    event.preventDefault();
    return;
  }

  // If it's a dot, prevent more than one
  if (newChar === "." && input.includes(".")) {
    event.preventDefault();
    return;
  }

  // Simulate the input as if character is added
  const newValue =
    input.slice(0, selectionStart) + newChar + input.slice(selectionStart);

  // If decimal part exceeds 3 digits, prevent it
  const parts = newValue.split(".");
  if (parts.length === 2 && parts[1].length > 2) {
    event.preventDefault();
  }
};
export const convertDateFormat = (str) => {
  const parts = str.split(" ");
  const monthMap = {
    January: "01",
    February: "02",
    March: "03",
    April: "04",
    May: "05",
    June: "06",
    July: "07",
    August: "08",
    September: "09",
    October: "10",
    November: "11",
    December: "12",
  };
  const formattedDate = `${parts[2]}-${monthMap[parts[1]]}-${parts[0]}`;
  return formattedDate;
};

export const convertTo24HourFormat = (timeStr) => {
  const [time, indicator] = timeStr.split(" ");
  const [hours, minutes] = time.split(":");
  const formattedHours =
    indicator === "PM" && hours !== "12" ? parseInt(hours, 10) + 12 : hours;
  const formattedTime = `${formattedHours}:${minutes}`;
  return formattedTime;
};
export const onlyLetters = (event) => {
  const charCode = event.which ? event.which : event.keyCode;
  // Allow letters and spaces
  if (
    (charCode < 65 || charCode > 90) && // A-Z
    (charCode < 97 || charCode > 122) && // a-z
    charCode !== 32 // Space
  ) {
    event.preventDefault();
  }
};

  // Helper function to format currency
  export const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return "₹0.00";
    const num = parseFloat(amount);
    return !isNaN(num) ? `₹${num.toFixed(2)}` : `₹${amount}`;
  };

  // Helper function to format attributes
 export const formatAttributes = (attributes) => {
    if (!attributes || !Array.isArray(attributes) || attributes.length === 0) {
      return null;
    }
    
    return attributes
      .map(attr => `${attr.type || attr.attributeType}: ${attr.value}`)
      .join(", ");
  };